import { EPromoDetailsActionTypes } from '../../actions/promoDetails';
import { IPromoDetailsState } from '../../types/promoDetails';
import { TReduxActions } from '../../types/redux';

export const defaultState: IPromoDetailsState = {
  analyticsProduct: null,
  isOpen: false,
  promo: null,
};

export function promoDetailsReducer(
  state: IPromoDetailsState = defaultState,
  action: TReduxActions,
): IPromoDetailsState {
  switch (action.type) {
    case EPromoDetailsActionTypes.OpenDetails:
      return {
        ...state,
        analyticsProduct: action.payload.product,
        isOpen: true,
        promo: action.payload.promo,
      };

    case EPromoDetailsActionTypes.CloseDetails:
      return {
        ...state,
        analyticsProduct: null,
        isOpen: false,
        promo: null,
      };

    default:
      return state;
  }
}
